import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { LoginComponent } from './login.component';
import { DynamicTranslationModule } from '../shared/dynamic-translation/dynamic-translation.module';
import { ExternalLoginComponent } from './external-login/external-login.component';
import { PartnerLoginComponent } from './partner-login/partner-login.component';

@NgModule({
  imports: [CommonModule, FormsModule, DynamicTranslationModule, RouterModule],
  declarations: [LoginComponent, ExternalLoginComponent, PartnerLoginComponent]
})
export class LoginModule {}
